import React, {
    ReactNode,
    createContext,
    useContext,
} from 'react';

import { ResourceNotificationSetting } from "../../../API";
import { ResourceNotificationSettingDraft } from '../../../lib/dashboard/types/ResourceNotificationSettingDraft';

interface ResourceNotificationSettingsContext {
    missedAssessmentNotificationSettings?: Array<ResourceNotificationSetting>;
    issueSubmissionNotificationSetting?: ResourceNotificationSetting;
    updateIssueSubmissionNotificationSetting?: (resourceNotificationSetting: ResourceNotificationSettingDraft) => (void | Promise<void>);
}

const ResourceNotificationSettingContext = createContext<ResourceNotificationSettingsContext | undefined>(undefined);

export const ResourceNotificationSettingsContextProvider: React.FC<{ children: ReactNode; value: ResourceNotificationSettingsContext; }> = ({ children, value }) => {
    return (
        <ResourceNotificationSettingContext.Provider value={value}>
            {children}
        </ResourceNotificationSettingContext.Provider>
    );
};

export const useResourceNotificationSettings = (): ResourceNotificationSettingsContext => {
    const context = useContext(ResourceNotificationSettingContext);
    if (!context) {
        throw new Error('useResourceNotificationSetting must be used within a ResourceNotificationSettingContextProvider');
    }
    return context;
};